import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  Container,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Menu } from "@mui/icons-material";
import Logo from "../assets/logo/rocketfuel-fulllogo.svg";
import { styles } from "./component.styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppSideBar from "./AppSideBar";
import AppButton from "./AppButton";
import AppFabSupport from "./AppFabSupport";
import { languages } from "../locale";
import { useTranslation } from "react-i18next";
import { persistLanguagePreference } from "../utils";
const AppBaseScreen = ({
  isHeader = true,
  headerTitle = null,
  headerSubTitle = null,
  navigate = false,
  navigatePath = "/home",
  headerTitle1 = null,
  headerSubTitle1 = null,
  cancel = null,
  backText = null,
  childsize = null,
  showLogo = true,
  showLocale = false,
  content = null,
  children
}) => {
  // const [pos, setPos] = useState(0);
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [color, setColor] = useState("transparent");
  const navigateTo = useNavigate();
  const handleNavigation = () => {
    if (typeof navigatePath === "string") {
      navigateTo(navigatePath);
    } else if (typeof navigatePath === "function") {
      navigatePath();
    }
  };

  const handleScroll = (e) => {
    if (e.target.scrollTop > 12) {
      setColor("#01335C");
    } else {
      setColor("transparent");
    }
  };

  const handleLocaleChange = (e) => {

    i18n.changeLanguage(e.target.value);
    persistLanguagePreference(e.target.value);
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Container
      disableGutters
      maxWidth={"100%"}
      className="AppBaseScreen"
      sx={{
        overflowX: "hidden",
        overflowY: "auto",
        height: "100%",
        width: "100%",
        position: "fixed",
      }}
      onScroll={handleScroll}
    >
      <AppSideBar open={open} setOpen={setOpen} />
      {!!isHeader && (
        <AppBar
          position="fixed"
          sx={{
            padding: 1,
            color: "#F8FAFF",
            transition: "0.5s",
            overflow: "hidden",
            backgroundColor: color,
            boxShadow:
              color !== "transparent"
                ? "5px 0px 27px -5px rgba(0, 0, 0, 0.3) !important"
                : "none",
          }}
        >
          <Toolbar
            variant="dense"
            sx={{ justifyContent: cancel ? "space-between" : "", paddingRight: '3px' }}
            className="AppBaseScreen_APPBAR"
          >
            {!!isHeader && !navigate && (
              <IconButton
                aria-label="tracker"
                aria-describedby="menu_icon_click"
                edge="start"
                color="inherit"
                sx={{ mr: 2 }}
                onClick={() => setOpen(!open)}
              >
                <Menu aria-label="tracker"
                  aria-describedby="menu_icon_click" />
              </IconButton>
            )}
            {!!navigate && (
              <>
                {backText && (
                  <AppButton
                    disableElevation
                    buttontheme={"transparent"}
                    startIcon={<ArrowBackIcon />}
                    sx={{
                      justifyContent: "flex-start",
                      margin: 0,
                      width: "auto",
                      color: "#D4D4D8",
                      paddingLeft: 1,
                    }}
                    className="AppBaseScreen_Back_action"
                    title={t(backText)}
                    onClick={handleNavigation}
                  />
                )}
                {!backText && (
                  <IconButton
                    aria-label="tracker"
                    aria-describedby="back_icon_click"
                    title="text"
                    edge="start"
                    color="inherit"
                    sx={{ mr: 2 }}
                    onClick={handleNavigation}
                  >
                    <ArrowBackIcon aria-label="tracker"
                      aria-describedby="back_icon_click" />
                  </IconButton>
                )}
              </>
            )}
            {!headerTitle && !cancel && showLogo && (
              <Box
                style={styles.logoContainer}
                marginLeft={!isSmallScreen ? "-4%" : "-10%"}
              >
                {!headerTitle && <Logo style={styles.logo} />}

              </Box>
            )}
            {!headerTitle && !cancel && showLocale && (
              <FormControl sx={{ minWidth: 70, color: '#fff' }} className="locale">
                <Select onChange={handleLocaleChange} name='locale'
                  value={i18n.language}
                  sx={{ color: '#fff', '& svg': { color: '#fff' }, '& fieldset': { border: 'none' }, '& MuiSelect-icon': { color: '#fff' } }}
                >
                  {Object.keys(languages).map((lng) => (
                    <MenuItem value={lng} key={lng} >{lng}</MenuItem>

                  ))}
                </Select>
              </FormControl>
            )}

            {!!headerTitle && (
              <Box style={styles.logoContainerHeader}>
                <Box
                  sx={{
                    display: "flex",
                    flexFlow: "column",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                      textTransform: "uppercase",
                      fontWeight: 700,
                      fontSize: 24,
                      textAlign: "center",
                      marginRight: !isSmallScreen ? "4%" : 5,
                    }}
                  >
                    {headerTitle}
                  </Typography>
                  {headerSubTitle && (
                    <Typography
                      variant="h6"
                      noWrap
                      component="div"
                      sx={{
                        fontWeight: 400,
                        fontSize: 14,
                        textAlign: "center",
                        marginRight: !isSmallScreen ? "5%" : 5,
                      }}
                    >
                      {headerSubTitle}
                    </Typography>
                  )}
                </Box>
              </Box>
            )}
            {!!cancel && (
              <AppButton
                disableElevation
                buttontheme={"transparent"}
                title={t("Cancel")}
                sx={{ margin: 0, fontSize: 16, width: 70 }}
                onClick={cancel}
              />
            )}
          </Toolbar>
        </AppBar>
      )}
      {!!isHeader && <Box marginTop={7}></Box>}
      {(!!headerTitle1 || !!headerSubTitle1) && (
        <Box style={styles.logoContainerHeader}>
          <Box
            sx={{
              display: "flex",
              flexFlow: "column",
              width: isSmallScreen ? "90%" : "50%",
              justifyContent: "center",
            }}
          >
            {!!headerTitle1 && (
              <Typography
                noWrap
                color={"#F8FAFF"}
                fontWeight={400}
                fontSize={14}
                textAlign="center"
              >
                {headerTitle1}
              </Typography>
            )}
            {headerSubTitle1 && (
              <Typography
                noWrap
                fontWeight={700}
                fontSize={24}
                textAlign="center"
                color={"#D4D4D8"}
              >
                {headerSubTitle1}
              </Typography>
            )}
            {content && (
              <Typography
                color={"#F8FAFF"}
                fontWeight={400}
                fontSize={12}
                marginTop={1}
                textAlign="center"
              >
                {content}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      <Container
        maxWidth={
          childsize ? childsize : isSmallScreen ? "xs" : "md"
        }
        sx={{
          display: "block",
          background: "transparent",
          boxShadow: "none",
        }}
      >
        {children}
      </Container>
      <AppFabSupport />
    </Container>
  );
};
AppBaseScreen.propTypes = {
  children: PropTypes.any,
  isHeader: PropTypes.bool,
  headerTitle: PropTypes.string,
  headerSubTitle: PropTypes.string,
  navigate: PropTypes.bool,
  navigatePath: PropTypes.any,
  headerTitle1: PropTypes.string,
  headerSubTitle1: PropTypes.string,
  cancel: PropTypes.func,
  backText: PropTypes.string,
  childsize: PropTypes.string,
  showLogo: PropTypes.bool,
  content: PropTypes.string,
};

export default AppBaseScreen;
